<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6">
        <v-img width="100%" :src="require('@/assets/keyvisual.jpg')"></v-img>
        <p class="pthanks">
          ขอบคุณที่ลงทะเบียนกับเรา<br />
          ติดตามข่าวสารโปรโมชั่นก่อนใครได้ที่
        </p>
      </v-col>
      <v-col cols="12">
        <v-row align="center" justify="center">
          <div align="left">
            <v-btn
              text
              @click="
                switchPage(
                  'https://www.facebook.com/SiamPremiumOutletsBangkok/'
                )
              "
            >
              <v-img
                :src="require('@/assets/fbicon.png')"
                class="mr-3 responsive-social"
              ></v-img>
              Siam Premium Outlets Bangkok </v-btn
            ><br /><br />
            <v-btn
              text
              @click="
                switchPage(
                  'https://www.instagram.com/siampremiumoutletsbangkok/?hl=en'
                )
              "
            >
              <v-img
                :src="require('@/assets/igicon.png')"
                class="mr-3 responsive-social"
              ></v-img
              >Siam Premium Outlets Bangkok </v-btn
            ><br /><br />
            <v-btn text @click="switchPage('https://lin.ee/2ogdgPyO2')">
              <v-img
                :src="require('@/assets/loaicon.png')"
                class="pl-0 mr-3 responsive-social"
              >
              </v-img>
              @SiamPremiumOutlets
            </v-btn>
          </div>
        </v-row>
      </v-col>
    </v-row>
  <br />
  </v-container>
</template>
<script>
export default {
  data: () => ({}),
  methods: {
    switchPage(link) {
      window.open(link, "_blank");
    },
  },
};
</script>
<style  >
.pthanks {
  text-align: center;
  font-family: "Kanit", sans-serif;
  color: #000;
  font-size: 1.2rem !important;
}
.responsive-social {
  width: 10%;
  height: auto;
}
</style>